module.exports = __webpack_public_path__ + "img/DSC00686.4fa40736.JPG";